<template>
  <div class="login-form-container">
    <div>
      <ChangeAuthenticatorComponent
        :action="usedComponent.factorAuth"
        :showCancel="false"
        @confirm="confirmAuthenticator"
        @reauthenticate="requireReauthenticate"
      />
    </div>
  </div>
</template>
<script>
import ChangeAuthenticatorComponent from '@/components/security/ChangeAuthenticatorComponent.vue';
import { mapOperation } from '@/components/security/Security.js';
import router from '@/router';
import helper from '@/util/signinHelper.js';
import { checkObjIsEmpty } from '@/util/utils.js';
export default {
  name: 'AddAuthentication',
  components: { ChangeAuthenticatorComponent },
  mixins: [],
  data() {
    return {
      usedComponent: {}
    };
  },
  mounted() {
    this.usedComponent = mapOperation('enable-auth-2fa');
    if (checkObjIsEmpty(this.usedComponent)) {
      router.push('/login');
    }
  },
  methods: {
    confirmAuthenticator(code) {
      if (code) {
        let tempAuth = this.$store.state.common.authHeaders;
        tempAuth['tCode'] = code;
        this.$store.commit('common/setAuthHeaders', tempAuth);
      }
      const lackAuthValues = this.$store.state.common.checkedAuthStatus.map(item => {
        return {
          ...item,
          verified: true,
          authenticated: item.type == 'totp' ? true : item?.authenticated
        };
      });
      this.$store.commit('common/setCheckedAuthStatus', lackAuthValues);
      if (lackAuthValues.every(item => item.authenticated)) {
        this.$store.state.common.loginCredentials.method == 'register'
          ? helper.register(this.$store.state.common.loginCredentials?.request?.a)
          : this.$store.state.common.loginCredentials.method == 'signInMobile'
          ? helper.signInMobile(
              this.$store.state.common.loginCredentials?.request?.countryCode,
              this.$store.state.common.loginCredentials?.request?.mobileLogin,
              this.$store.state.common.loginCredentials?.request?.passwordLogin
            )
          : helper.signIn(
              this.$store.state.common.loginCredentials?.request?.email,
              this.$store.state.common.loginCredentials?.request?.passwordLogin
            );
      } else {
        const tempObj = lackAuthValues.find(item => item.path != this.$router.currentRoute.path && !item.authenticated);
        if (tempObj && tempObj?.path) this.$router.push(tempObj.path);
      }
    },
    requireReauthenticate() {
      this.$router.push('/login');
    }
  }
};
</script>
<style lang="scss">
#loginClient {
  .right-panel {
    .login-form-container {
      #ChangeAuthenticatorComponent {
        /deep/ .el-dialog {
          max-width: 820px;
        }
      }
      #changeAuthenticator .process_box {
        background: rgba(0, 81, 255, 0.05);
        border-radius: 20px;
        @media (min-width: 992px) and (max-width: 1450px) {
          .process_items div {
            width: 160px;
          }
        }
      }
    }
  }
}
</style>
